import { config } from '../../../../config';

export const USER_GUIDE_CHIP_QUERY_PARAM = 'chip';
export const USER_GUIDE_SCOPE_QUERY_PARAM = 'scope';
export const ALL_USER_GUIDE_CHIPS = 'All';
export const USER_GUIDE_CHIP_SKELETON_ITEMS = [1, 2, 3];
export const USER_GUIDE_BANNER_IMAGE = `${config.basePath}/images/user-guides-banner.jpeg`;
export const USER_GUIDE_BANNER_DESCRIPTION =
    'A channel dedicated to providing Neon users with helpful guides and information relating to the Neon application suite.';
export const USER_GUIDE_BANNER_PUBLISHER = 'Neon Product Team';
